export default {
  translations: {
    page: {
      helloworld: "Hello World with I18N",
    },
  },
};
